export interface CommunicationConfigurations {
  liveChat?: LiveChatConfigurations
}

export interface LiveChatConfigurations {
  isAllowed: boolean,
  infobip?: InfobipConfigurations,
}

export interface InfobipConfigurations {
  widgetId: string
  securityKey: {
    id: string
    key: string
  },
}

export const defaultCommunicationConfig: CommunicationConfigurations = {
  liveChat: undefined,
}
